/**
 * PartiesAttorneys Styled Components
 * Extracted from PartiesAttorneys for better separation of concerns
 */

import { Box, Text, styled } from '@ltvco/refresh-lib/theme';

import {
  IconCircle,
  getTableCellPrimaryStyles,
  getTableCellSecondaryStyles,
} from '../../../shared/components';

// Re-export IconCircle with custom props for party icon
export const PartyIconContainer = styled(IconCircle)({});
PartyIconContainer.defaultProps = { size: 16, bgOpacity: 0.12 };

export const PartiesAttorneysContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  width: '100%',
  marginTop: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(1),
    marginTop: theme.spacing(1.5),
    padding: theme.spacing(0, 1),
  },
}));

export const SectionTitle = styled(Text)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '20px',
  fontWeight: 700,
  lineHeight: '32px',
  color: theme.palette.text.primary,
  width: '100%',
  marginBottom: theme.spacing(1.5),
  marginLeft: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
    lineHeight: '24px',
    marginBottom: theme.spacing(1),
    marginLeft: 0,
    padding: theme.spacing(0, 1),
  },
}));

export const PartiesGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: theme.spacing(1.5),
  width: '100%',
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
    gap: theme.spacing(1),
  },
}));

export const PartyCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  borderRadius: '16px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.common.white,
  minHeight: 0,
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    borderRadius: '12px',
  },
}));

export const PartyHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0.75),
  },
}));

export const PartyNameRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0.75),
  },
}));

export const PartyName = styled(Text)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '24px',
  color: theme.palette.text.primary,
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
    lineHeight: '22px',
  },
}));

export const PartyExtraInfo = styled(Text)(({ theme }) => ({
  ...getTableCellPrimaryStyles(theme),
  flex: 1,
  minWidth: 0,
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '20px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
}));

export const Divider = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '1px',
  backgroundColor: theme.palette.divider,
}));

export const AttorneySection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0.75),
  },
}));

export const RepresentedByLabel = styled(Text)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '12px',
  fontWeight: 700,
  lineHeight: '16px',
  color: theme.palette.text.secondary,
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
    lineHeight: '16px',
  },
}));

export const AttorneyInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(0.75),
  },
}));

export const AttorneyName = styled(Text)(({ theme }) => ({
  ...getTableCellPrimaryStyles(theme),
  marginBottom: 0,
  marginTop: 0,
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '20px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
}));

export const AttorneyAddress = styled(Text)(({ theme }) => ({
  ...getTableCellSecondaryStyles(theme),
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '20px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
}));

export const AttorneyPhone = styled(Text)(({ theme }) => ({
  ...getTableCellSecondaryStyles(theme),
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '20px',
  },
}));

export const AttorneyRoleText = styled(Text)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.text.secondary,
  textTransform: 'uppercase',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
    lineHeight: '16px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
  },
}));

export const NoAttorneyText = styled(Text)(({ theme }) => ({
  ...getTableCellSecondaryStyles(theme),
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    lineHeight: '20px',
  },
}));
